import { useState } from "react";

export function Workshops() {
  const [status, setStatus] = useState<string | null>(null);

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const payload = Object.fromEntries(fd.entries());
    setStatus("Submitting...");
    const res = await fetch("/api/workshops/signup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data: unknown = await res.json();
    const message =
      typeof data === "object" &&
      data !== null &&
      "message" in data &&
      typeof (data as { message?: unknown }).message === "string"
        ? (data as { message: string }).message
        : undefined;
    setStatus(
      res.ok ? "We saved your spot. We'll be in touch!" : message || "Something went wrong"
    );
    if (res.ok) e.currentTarget.reset();
  }

  return (
    <div className="max-w-6xl mx-auto container-px py-14">
      <header className="mb-10">
        <h1 className="text-3xl md:text-4xl display">Workshops</h1>
        <p className="text-foreground/70 mt-3 max-w-2xl">
          Small-group hand-building and wheel sessions. All levels welcome. Materials and firing
          included.
        </p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <section className="lg:col-span-2 space-y-6">
          <div className="rounded-xl border border-border bg-card p-6">
            <h2 className="display text-2xl">Upcoming Sessions</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center justify-between border-b border-border/60 pb-3">
                <div>
                  <p className="font-medium">Weekend Wheel Basics</p>
                  <p className="text-foreground/70">Saturdays · 10:00–12:00 · 4 weeks</p>
                </div>
                <span className="text-primary font-medium">฿4,200</span>
              </li>
              <li className="flex items-center justify-between border-b border-border/60 pb-3">
                <div>
                  <p className="font-medium">Hand-building for Beginners</p>
                  <p className="text-foreground/70">Wednesdays · 18:30–20:30 · 3 weeks</p>
                </div>
                <span className="text-primary font-medium">฿3,200</span>
              </li>
              <li className="flex items-center justify-between">
                <div>
                  <p className="font-medium">Glazing & Finishes</p>
                  <p className="text-foreground/70">Monthly · Sunday Intensive</p>
                </div>
                <span className="text-primary font-medium">฿1,600</span>
              </li>
            </ul>
          </div>
        </section>

        <aside className="rounded-xl border border-border bg-card p-6">
          <h3 className="display text-xl">Reserve a Spot</h3>
          <form onSubmit={submit} className="mt-4 space-y-4">
            <div>
              <label className="block text-sm mb-1">Name</label>
              <input
                name="name"
                required
                className="w-full rounded-md border border-input bg-background px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Email</label>
              <input
                type="email"
                name="email"
                required
                className="w-full rounded-md border border-input bg-background px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Preferred Session</label>
              <select
                name="session"
                className="w-full rounded-md border border-input bg-background px-3 py-2"
              >
                <option>Weekend Wheel Basics</option>
                <option>Hand-building for Beginners</option>
                <option>Glazing & Finishes</option>
              </select>
            </div>
            <button className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm hover:opacity-90 transition">
              Request Booking
            </button>
            {status && <p className="text-xs text-foreground/70">{status}</p>}
          </form>
        </aside>
      </div>
    </div>
  );
}
